import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

export default function NotFoundPage() {
  const { t } = useTranslation()

  return (
    <div
      style={{
        minHeight: 360,
        display: 'grid',
        placeItems: 'center',
        padding: 32,
        fontFamily: 'Lato, sans-serif',
        color: '#0B1E2D',
      }}
    >
      <div style={{ maxWidth: 420, textAlign: 'center' }}>
        <p
          style={{
            margin: 0,
            fontSize: 13,
            fontWeight: 700,
            letterSpacing: '0.12em',
            textTransform: 'uppercase',
            color: '#5F7484',
          }}
        >
          404
        </p>
        <h1 style={{ margin: '8px 0 10px', fontSize: 28, fontWeight: 600 }}>
          {t('notFoundPage.title')}
        </h1>
        <p style={{ margin: '0 0 18px', color: '#5F7484', fontSize: 15.5 }}>
          {t('notFoundPage.message')}
        </p>
        <Link
          to="/"
          style={{
            color: '#076B5C',
            fontWeight: 600,
            textDecoration: 'none',
          }}
        >
          {t('notFoundPage.back')}
        </Link>
      </div>
    </div>
  )
}
